import type { RouteObject } from 'react-router';

/**
 * Create paths from RouteObject.
 *
 * @param {RouteObject} route Route.
 *
 * @returns {string[]} Paths.
 */
export function createPaths(route: RouteObject): string[] {
  const result = new Set<string>();

  (function createPath(parentPath: string, { children, path }: RouteObject) {
    const currentPath = path ? `${parentPath}/${path}` : parentPath;

    if (!children?.length) {
      result.add(currentPath);

      return;
    }

    children.forEach((child) => {
      createPath(currentPath, child);
    });
  })('', route);

  return Array.from(result);
}
